// import React from "react";

// export default function BreakdownTable({
//   title = "Breakdown",
//   recomputeFromComponents,
//   data = [],
//   selectedIds = [],
//   onSelectAll = () => {},
//   onSelectOne = () => {},
//   onChange = () => {}, // quantity change
//   onChange2 = () => {}, // quantityApprove change
//   onChangeDirectAmount = () => {},
//   onAdd = () => {},
//   onDelete = () => {},
//   disableAdd = false,
//   hasQuantity = true,
//   showUOM = true,
//   showSKU = true,
//   showCost = false, // kept for backward-compat
//   showAddButton = true,
//   disableQty = false,
//   checkbox = true,
//   showQuantityApprove = false,
//   disableQtyApprove = false,
//   showQuantityReceivePartial = false,
//   showRemaining = false,

//   showAmountDirect = false,

//   // NEW: toggles for the new columns / details row
//   showPrice = false,
//   showReference = false,
//   showWarehouse = false,
//   showDetailsRow = false, // shows Net Price / Discount under each row

//   // NEW: handlers for the new cells/fields
//   onPriceChange = () => {},
//   onReferenceChange = () => {},
//   onWarehouseChange = () => {},
//   onNetPriceChange = () => {},
//   onDiscountChange = () => {},
// }) {
//   const isAllSelected = data.length > 0 && selectedIds.length === data.length;

//   // compute total colSpan for the details row / empty state
//   const baseCols =
//     (checkbox ? 1 : 0) +
//     (showSKU ? 1 : 0) +
//     1 + // Item Name
//     (showUOM ? 1 : 0) +
//     (showPrice ? 1 : 0) +
//     (showReference ? 1 : 0) +
//     (showWarehouse ? 1 : 0) +
//     1 + // Quantity
//     (showQuantityApprove ? 1 : 0) +
//     (showAmountDirect ? 1 : 0) +
//     (showRemaining ? 1 : 0) +
//     1;
//   // (hasQuantity ? 1 : 0);
//   // (showQuantity ? 1 : 0);

//   console.log("data", data);

//   // Put these at the top of your component (once)
//   const php = React.useMemo(
//     () =>
//       new Intl.NumberFormat("en-PH", { style: "currency", currency: "PHP" }),
//     [],
//   );

//   const toNum = (v) => {
//     const n = parseFloat(v);
//     return Number.isFinite(n) ? n : 0;
//   };

//   const totals = React.useMemo(() => {
//     return (data || []).reduce(
//       (acc, row) => {
//         const qty = toNum(row?.quantity);
//         const unitCost = toNum(row?.cost); // <-- use cost only
//         const lineAmount = qty * unitCost;

//         acc.qty += qty;
//         acc.amount += lineAmount;
//         return acc;
//       },
//       { qty: 0, amount: 0 },
//     );
//   }, [data]);

//   return (
//     <div className="mt-4">
//       <div className="d-flex justify-content-between align-items-center">
//         <h6 className="mb-0 fw-bold" style={{ color: "#82c14a" }}>
//           {title}
//         </h6>
//         <div className="d-flex align-items-center gap-2">
//           {selectedIds.length > 0 && (
//             <button
//               type="button"
//               onClick={onDelete}
//               className="btn p-0 border-0"
//               style={{
//                 backgroundColor: "transparent",
//                 width: "36px",
//                 height: "36px",
//               }}
//               title="Delete selected items"
//             >
//               <i
//                 className="bi bi-trash"
//                 style={{ fontSize: "24px", color: "red" }}
//               />
//             </button>
//           )}
//           {showAddButton && (
//             <button
//               type="button"
//               onClick={onAdd}
//               className="btn p-0 border-0"
//               disabled={disableAdd && !hasQuantity}
//               style={{
//                 backgroundColor: "transparent",
//                 width: "36px",
//                 height: "36px",
//                 opacity: !disableAdd || hasQuantity ? 1 : 0.5,
//                 cursor: !disableAdd || hasQuantity ? "pointer" : "not-allowed",
//               }}
//               title={
//                 !disableAdd || hasQuantity
//                   ? "Add item"
//                   : "Please fill out required fields before adding"
//               }
//             >
//               <i
//                 className="bi bi-plus-circle"
//                 style={{ fontSize: "24px", color: "#82c14a" }}
//               />
//             </button>
//           )}
//         </div>
//       </div>

//       <div
//         className="table-responsive mt-2"
//         style={{ border: "1px solid #82c14a", borderRadius: "6px" }}
//       >
//         <table className="table mb-0">
//           <thead>
//             <tr>
//               {checkbox && (
//                 <th
//                   scope="col"
//                   style={{ backgroundColor: "#82c14a", color: "white" }}
//                 >
//                   <input
//                     type="checkbox"
//                     checked={isAllSelected}
//                     onChange={onSelectAll}
//                   />
//                 </th>
//               )}
//               {showSKU && (
//                 <th
//                   scope="col"
//                   style={{ backgroundColor: "#82c14a", color: "white" }}
//                 >
//                   SKU
//                 </th>
//               )}
//               <th
//                 scope="col"
//                 style={{ backgroundColor: "#82c14a", color: "white" }}
//               >
//                 Item Name
//               </th>
//               {showUOM && (
//                 <th
//                   scope="col"
//                   style={{ backgroundColor: "#82c14a", color: "white" }}
//                 >
//                   UOM
//                 </th>
//               )}
//               {showCost && (
//                 <th
//                   scope="col"
//                   style={{ backgroundColor: "#82c14a", color: "white" }}
//                 >
//                   Cost
//                 </th>
//               )}
//               {showAmountDirect && (
//                 <th
//                   scope="col"
//                   style={{ backgroundColor: "#82c14a", color: "white" }}
//                 >
//                   Amount
//                 </th>
//               )}
//               {/* {showAmountDirect && (
//                 <th
//                   scope="col"
//                   style={{ backgroundColor: "#82c14a", color: "white" }}
//                 >
//                   Quantity
//                 </th>
//               )} */}

//               {showPrice && (
//                 <th
//                   scope="col"
//                   style={{ backgroundColor: "#82c14a", color: "white" }}
//                 >
//                   Price
//                 </th>
//               )}
//               {showReference && (
//                 <th
//                   scope="col"
//                   style={{ backgroundColor: "#82c14a", color: "white" }}
//                 >
//                   Reference #
//                 </th>
//               )}
//               {showWarehouse && (
//                 <th
//                   scope="col"
//                   style={{ backgroundColor: "#82c14a", color: "white" }}
//                 >
//                   Warehouse
//                 </th>
//               )}
//               <th
//                 scope="col"
//                 style={{ backgroundColor: "#82c14a", color: "white" }}
//               >
//                 Quantity
//               </th>
//               {showAmountDirect && (
//                 <th
//                   scope="col"
//                   style={{ backgroundColor: "#82c14a", color: "white" }}
//                 >
//                   Cost
//                 </th>
//               )}
//               {showRemaining && (
//                 <th
//                   scope="col"
//                   style={{ backgroundColor: "#82c14a", color: "white" }}
//                 >
//                   Remaining
//                 </th>
//               )}
//               {showQuantityApprove && (
//                 <th
//                   scope="col"
//                   style={{ backgroundColor: "#82c14a", color: "white" }}
//                 >
//                   Quantity Approve
//                 </th>
//               )}
//               {showQuantityReceivePartial && (
//                 <th
//                   scope="col"
//                   style={{ backgroundColor: "#82c14a", color: "white" }}
//                 >
//                   Quantity Receive
//                 </th>
//               )}
//             </tr>
//           </thead>

//           <tbody>
//             {data.length > 0 ? (
//               data.map((row, index) => (
//                 <React.Fragment key={row.id || index}>
//                   <tr>
//                     {checkbox && (
//                       <td>
//                         <input
//                           type="checkbox"
//                           checked={selectedIds.includes(row.id)}
//                           onChange={(e) => onSelectOne(e, row.id)}
//                         />
//                       </td>
//                     )}
//                     {showSKU && <td>{row.sku}</td>}
//                     <td>{row.itemName}</td>
//                     {showUOM && <td>{row.uom?.name || ""}</td>}
//                     {showCost && <td>{row?.cost || ""}</td>}
//                     {showPrice && <td>{row?.cost || ""}</td>}
//                     {showAmountDirect && (
//                       <td>
//                         {" "}
//                         <input
//                           type="number"
//                           min="0"
//                           step="any" // allow 1.5, 0.25, etc.
//                           inputMode="decimal" // better mobile keyboard
//                           disabled={disableQty}
//                           className="form-control form-control-sm text-center border-success"
//                           style={{ width: "120px", margin: "0 auto" }}
//                           value={row.amountDirect ?? ""}
//                           onBlur={recomputeFromComponents}
//                           onChange={(e) => onChangeDirectAmount(e, index)} // ensure you don't parseInt() later
//                         />
//                       </td>
//                     )}

//                     {showReference && (
//                       <td>
//                         <input
//                           type="text"
//                           className="form-control form-control-sm text-center border-success"
//                           style={{ width: 160, margin: "0 auto" }}
//                           value={row.reference || ""}
//                           onChange={(e) => onReferenceChange(e, index)}
//                           placeholder="Ref #"
//                         />
//                       </td>
//                     )}

//                     {showWarehouse && (
//                       <td>
//                         {/* simple text input; swap to <select> if you have options */}
//                         <input
//                           type="text"
//                           className="form-control form-control-sm text-center border-success"
//                           style={{ width: 160, margin: "0 auto" }}
//                           value={row.warehouse || row.warehouseName || ""}
//                           onChange={(e) => onWarehouseChange(e, index)}
//                           placeholder="Warehouse"
//                         />
//                       </td>
//                     )}

//                     {/* <td>
//                       <input
//                         type="number"
//                         min="0"
//                         disabled={disableQty}
//                         className="form-control form-control-sm text-center border-success"
//                         style={{ width: "80px", margin: "0 auto" }}
//                         value={row.quantity ?? ""}
//                         onChange={(e) => onChange(e, index)}
//                       />
//                     </td> */}
//                     <td>
//                       <input
//                         type="number"
//                         min="0"
//                         step="any" // allow 1.5, 0.25, etc.
//                         inputMode="decimal" // better mobile keyboard
//                         disabled={disableQty}
//                         className="form-control form-control-sm text-center border-success"
//                         style={{ width: "120px", margin: "0 auto" }}
//                         value={row.quantity ?? ""}
//                         onBlur={recomputeFromComponents}
//                         onChange={(e) => onChange(e, index)} // ensure you don't parseInt() later
//                       />
//                     </td>

//                     {showAmountDirect && (
//                       <td className="text-center">{row?.costDirect || "0"}</td>
//                     )}

//                     {showRemaining && (
//                       <td className="text-center">{row?.remaining || "0"}</td>
//                     )}

//                     {showQuantityApprove && (
//                       <td>
//                         <input
//                           type="number"
//                           min="0"
//                           disabled={disableQtyApprove}
//                           className="form-control form-control-sm text-center border-success"
//                           style={{ width: "80px", margin: "0 auto" }}
//                           value={row.quantityApprove ?? ""}
//                           onChange={(e) => onChange2(e, index)}
//                         />
//                       </td>
//                     )}

//                     {showQuantityReceivePartial && (
//                       <td>
//                         <input
//                           type="number"
//                           min="0"
//                           disabled={disableQtyApprove}
//                           className="form-control form-control-sm text-center border-success"
//                           style={{ width: "80px", margin: "0 auto" }}
//                           // value={row.quantityReceivePartial ?? ""}
//                           // value={row.quantityReceivePartial ?? ""}
//                           onChange={(e) => onChange2(e, index)}
//                           defaultValue={"0"}
//                         />
//                       </td>
//                     )}
//                   </tr>
//                   {showDetailsRow && (
//                     <tr>
//                       <td colSpan={baseCols} style={{ background: "#fff" }}>
//                         <div className="py-2 px-2">
//                           {/* Net Price - row */}
//                           <div className="d-flex  align-items-center mb-2">
//                             <label
//                               className="mb-0 me-2"
//                               style={{ minWidth: 110 }}
//                             >
//                               Net Price :
//                             </label>
//                             <input
//                               type="number"
//                               min="0"
//                               step="0.01"
//                               className="form-control form-control-sm text-end"
//                               style={{ width: 160 }}
//                               value={row.netPrice ?? row.cost ?? ""}
//                               onChange={(e) => onNetPriceChange(e, index)}
//                               placeholder="100"
//                             />
//                           </div>

//                           {/* Discount - row */}
//                           <div className="d-flex  align-items-center mb-2">
//                             <label
//                               className="mb-0 me-2"
//                               style={{ minWidth: 110 }}
//                             >
//                               Discount :
//                             </label>
//                             <input
//                               type="number"
//                               min="0"
//                               step="0.01"
//                               className="form-control form-control-sm text-end"
//                               style={{ width: 160 }}
//                               value={row.discount ?? ""}
//                               onChange={(e) => onDiscountChange(e, index)}
//                               placeholder="50"
//                             />
//                           </div>

//                           {/* Total Amount (read-only) - row */}
//                           <div className="d-flex  align-items-center">
//                             <label
//                               className="mb-0 me-2"
//                               style={{ minWidth: 110 }}
//                             >
//                               Total Amount :
//                             </label>
//                             <input
//                               type="number"
//                               min="0"
//                               step="0.01"
//                               style={{ width: 160 }}
//                               className="form-control form-control-sm text-end"
//                               value={row?.cost * row?.quantity}
//                               onChange={(e) => onDiscountChange(e, index)}
//                               placeholder="50"
//                             />
//                           </div>
//                         </div>
//                       </td>
//                     </tr>
//                   )}
//                 </React.Fragment>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan={baseCols} className="text-center py-4 text-muted">
//                   No items found. <br /> Please add item first.
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }

import React from "react";

export default function BreakdownTable({
  title = "Breakdown",
  recomputeFromComponents,
  data = [],
  selectedIds = [],
  onSelectAll = () => {},
  onSelectOne = () => {},
  onChange = () => {},
  onChange2 = () => {},
  onChangeDirectAmount = () => {},
  onAdd = () => {},
  onDelete = () => {},
  disableAdd = false,
  hasQuantity = true,
  showUOM = true,
  showSKU = true,
  showCost = false,
  showAddButton = true,
  disableQty = false,
  checkbox = true,
  showQuantityApprove = false,
  disableQtyApprove = false,
  showQuantityReceivePartial = false,
  showRemaining = false,
  showAmountDirect = false,
  showPrice = false,
  showReference = false,
  showWarehouse = false,
  showDetailsRow = false,
  onPriceChange = () => {},
  onReferenceChange = () => {},
  onWarehouseChange = () => {},
  onNetPriceChange = () => {},
  onDiscountChange = () => {},
}) {
  const isAllSelected = data.length > 0 && selectedIds.length === data.length;

  const baseCols =
    (checkbox ? 1 : 0) +
    (showSKU ? 1 : 0) +
    1 +
    (showUOM ? 1 : 0) +
    (showPrice ? 1 : 0) +
    (showReference ? 1 : 0) +
    (showWarehouse ? 1 : 0) +
    1 +
    (showQuantityApprove ? 1 : 0) +
    (showAmountDirect ? 1 : 0) +
    (showRemaining ? 1 : 0) +
    1;

  console.log("data", data);

  const php = React.useMemo(
    () =>
      new Intl.NumberFormat("en-PH", { style: "currency", currency: "PHP" }),
    [],
  );

  const toNum = (v) => {
    const n = parseFloat(v);
    return Number.isFinite(n) ? n : 0;
  };

  const totals = React.useMemo(() => {
    return (data || []).reduce(
      (acc, row) => {
        const qty = toNum(row?.quantity);
        const unitCost = toNum(row?.cost);
        const lineAmount = qty * unitCost;

        acc.qty += qty;
        acc.amount += lineAmount;
        return acc;
      },
      { qty: 0, amount: 0 },
    );
  }, [data]);

  return (
    <div className="mt-4">
      {/* Modern Header Section */}
      <div
        className="rounded-4 p-3 mb-3 position-relative overflow-hidden"
        style={{
          background: "linear-gradient(135deg, #82c14a 0%, #6aa83a 100%)",
          boxShadow: "0 8px 24px rgba(130, 193, 74, 0.25)",
        }}
      >
        {/* Decorative elements */}
        <div
          className="position-absolute"
          style={{
            width: "120px",
            height: "120px",
            background: "rgba(255, 255, 255, 0.1)",
            borderRadius: "50%",
            top: "-30px",
            right: "-20px",
          }}
        ></div>
        <div
          className="position-absolute"
          style={{
            width: "80px",
            height: "80px",
            background: "rgba(255, 255, 255, 0.08)",
            borderRadius: "50%",
            bottom: "-20px",
            left: "15%",
          }}
        ></div>

        <div className="d-flex justify-content-between align-items-center position-relative">
          <div className="d-flex align-items-center gap-3">
            <div
              className="bg-white bg-opacity-25 rounded-3 d-flex align-items-center justify-content-center"
              style={{ width: "48px", height: "48px" }}
            >
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="2.5"
              >
                <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
              </svg>
            </div>
            <div>
              <h5 className="mb-0 text-white fw-bold">{title}</h5>
              <p className="mb-0 text-white-50 small">
                Manage your breakdown items
              </p>
            </div>
          </div>

          <div className="d-flex align-items-center gap-2">
            {selectedIds.length > 0 && (
              <button
                type="button"
                onClick={onDelete}
                className="btn btn-light btn-sm rounded-3 shadow-sm d-flex align-items-center gap-2 px-3"
                style={{
                  transition: "all 0.3s ease",
                  border: "none",
                }}
                title="Delete selected items"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#dc3545"
                  strokeWidth="2"
                >
                  <path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" />
                </svg>
                <span className="text-danger fw-semibold">
                  Delete ({selectedIds.length})
                </span>
              </button>
            )}
            {showAddButton && (
              <button
                type="button"
                onClick={onAdd}
                className="btn btn-light btn-sm rounded-3 shadow-sm d-flex align-items-center gap-2 px-3"
                disabled={disableAdd && !hasQuantity}
                style={{
                  transition: "all 0.3s ease",
                  border: "none",
                  opacity: !disableAdd || hasQuantity ? 1 : 0.5,
                  cursor:
                    !disableAdd || hasQuantity ? "pointer" : "not-allowed",
                }}
                title={
                  !disableAdd || hasQuantity
                    ? "Add item"
                    : "Please fill out required fields before adding"
                }
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#82c14a"
                  strokeWidth="2.5"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="M12 8v8M8 12h8" />
                </svg>
                <span className="fw-semibold" style={{ color: "#82c14a" }}>
                  Add Item
                </span>
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Modern Table Container */}
      <div
        className="rounded-4 overflow-hidden shadow-sm border-0"
        style={{
          background: "white",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
        }}
      >
        <div className="table-responsive">
          <table
            className="table mb-0"
            style={{ borderCollapse: "separate", borderSpacing: 0 }}
          >
            <thead>
              <tr
                style={{
                  background:
                    "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                }}
              >
                {checkbox && (
                  <th
                    scope="col"
                    className="py-3 px-4"
                    style={{
                      fontWeight: "600",
                      fontSize: "0.85rem",
                      color: "#495057",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      borderBottom: "2px solid #82c14a",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={isAllSelected}
                      onChange={onSelectAll}
                      className="form-check-input"
                      style={{ cursor: "pointer" }}
                    />
                  </th>
                )}
                {showSKU && (
                  <th
                    scope="col"
                    className="py-3 px-4"
                    style={{
                      fontWeight: "600",
                      fontSize: "0.85rem",
                      color: "#495057",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      borderBottom: "2px solid #82c14a",
                    }}
                  >
                    SKU
                  </th>
                )}
                <th
                  scope="col"
                  className="py-3 px-4"
                  style={{
                    fontWeight: "600",
                    fontSize: "0.85rem",
                    color: "#495057",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    borderBottom: "2px solid #82c14a",
                  }}
                >
                  Item Name
                </th>
                {showUOM && (
                  <th
                    scope="col"
                    className="py-3 px-4"
                    style={{
                      fontWeight: "600",
                      fontSize: "0.85rem",
                      color: "#495057",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      borderBottom: "2px solid #82c14a",
                    }}
                  >
                    UOM
                  </th>
                )}
                {showCost && (
                  <th
                    scope="col"
                    className="py-3 px-4"
                    style={{
                      fontWeight: "600",
                      fontSize: "0.85rem",
                      color: "#495057",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      borderBottom: "2px solid #82c14a",
                    }}
                  >
                    Cost
                  </th>
                )}
                {showAmountDirect && (
                  <th
                    scope="col"
                    className="py-3 px-4"
                    style={{
                      fontWeight: "600",
                      fontSize: "0.85rem",
                      color: "#495057",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      borderBottom: "2px solid #82c14a",
                    }}
                  >
                    Amount
                  </th>
                )}
                {showPrice && (
                  <th
                    scope="col"
                    className="py-3 px-4"
                    style={{
                      fontWeight: "600",
                      fontSize: "0.85rem",
                      color: "#495057",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      borderBottom: "2px solid #82c14a",
                    }}
                  >
                    Price
                  </th>
                )}
                {showReference && (
                  <th
                    scope="col"
                    className="py-3 px-4"
                    style={{
                      fontWeight: "600",
                      fontSize: "0.85rem",
                      color: "#495057",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      borderBottom: "2px solid #82c14a",
                    }}
                  >
                    Reference #
                  </th>
                )}
                {showWarehouse && (
                  <th
                    scope="col"
                    className="py-3 px-4"
                    style={{
                      fontWeight: "600",
                      fontSize: "0.85rem",
                      color: "#495057",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      borderBottom: "2px solid #82c14a",
                    }}
                  >
                    Warehouse
                  </th>
                )}
                <th
                  scope="col"
                  className="py-3 px-4"
                  style={{
                    fontWeight: "600",
                    fontSize: "0.85rem",
                    color: "#495057",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    borderBottom: "2px solid #82c14a",
                  }}
                >
                  Quantity
                </th>
                {showAmountDirect && (
                  <th
                    scope="col"
                    className="py-3 px-4"
                    style={{
                      fontWeight: "600",
                      fontSize: "0.85rem",
                      color: "#495057",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      borderBottom: "2px solid #82c14a",
                    }}
                  >
                    Cost
                  </th>
                )}
                {showRemaining && (
                  <th
                    scope="col"
                    className="py-3 px-4"
                    style={{
                      fontWeight: "600",
                      fontSize: "0.85rem",
                      color: "#495057",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      borderBottom: "2px solid #82c14a",
                    }}
                  >
                    Remaining
                  </th>
                )}
                {showQuantityApprove && (
                  <th
                    scope="col"
                    className="py-3 px-4"
                    style={{
                      fontWeight: "600",
                      fontSize: "0.85rem",
                      color: "#495057",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      borderBottom: "2px solid #82c14a",
                    }}
                  >
                    Quantity Approve
                  </th>
                )}
                {showQuantityReceivePartial && (
                  <th
                    scope="col"
                    className="py-3 px-4"
                    style={{
                      fontWeight: "600",
                      fontSize: "0.85rem",
                      color: "#495057",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      borderBottom: "2px solid #82c14a",
                    }}
                  >
                    Quantity Receive
                  </th>
                )}
              </tr>
            </thead>

            <tbody>
              {data.length > 0 ? (
                data.map((row, index) => (
                  <React.Fragment key={row.id || index}>
                    <tr
                      className="border-bottom"
                      style={{
                        transition: "all 0.2s ease",
                        background: index % 2 === 0 ? "#ffffff" : "#f8f9fa",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = "#f0f8ea";
                        e.currentTarget.style.transform = "scale(1.005)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background =
                          index % 2 === 0 ? "#ffffff" : "#f8f9fa";
                        e.currentTarget.style.transform = "scale(1)";
                      }}
                    >
                      {checkbox && (
                        <td className="py-3 px-4">
                          <input
                            type="checkbox"
                            checked={selectedIds.includes(row.id)}
                            onChange={(e) => onSelectOne(e, row.id)}
                            className="form-check-input"
                            style={{ cursor: "pointer" }}
                          />
                        </td>
                      )}
                      {showSKU && (
                        <td className="py-3 px-4">
                          <span
                            className="badge bg-light text-dark border px-3 py-2"
                            style={{ fontWeight: "500" }}
                          >
                            {row.sku}
                          </span>
                        </td>
                      )}
                      <td className="py-3 px-4">
                        <span className="fw-semibold text-dark">
                          {row.itemName}
                        </span>
                      </td>
                      {showUOM && (
                        <td className="py-3 px-4">
                          <span className="text-muted">
                            {row.uom?.name || ""}
                          </span>
                        </td>
                      )}
                      {showCost && (
                        <td className="py-3 px-4">
                          <span className="fw-semibold text-success">
                            {row?.cost || ""}
                          </span>
                        </td>
                      )}
                      {showPrice && (
                        <td className="py-3 px-4">
                          <span className="fw-semibold text-success">
                            {row?.cost || ""}
                          </span>
                        </td>
                      )}
                      {showAmountDirect && (
                        <td className="py-3 px-4">
                          <input
                            type="number"
                            min="0"
                            step="any"
                            inputMode="decimal"
                            disabled={disableQty}
                            className="form-control form-control-sm text-center rounded-3 border-0 shadow-sm"
                            style={{
                              width: "120px",
                              margin: "0 auto",
                              background: "#f8f9fa",
                              fontWeight: "500",
                            }}
                            value={row.amountDirect ?? ""}
                            onBlur={recomputeFromComponents}
                            onChange={(e) => onChangeDirectAmount(e, index)}
                          />
                        </td>
                      )}

                      {showReference && (
                        <td className="py-3 px-4">
                          <input
                            type="text"
                            className="form-control form-control-sm text-center rounded-3 border-0 shadow-sm"
                            style={{
                              width: 160,
                              margin: "0 auto",
                              background: "#f8f9fa",
                              fontWeight: "500",
                            }}
                            value={row.reference || ""}
                            onChange={(e) => onReferenceChange(e, index)}
                            placeholder="Ref #"
                          />
                        </td>
                      )}

                      {showWarehouse && (
                        <td className="py-3 px-4">
                          <input
                            type="text"
                            className="form-control form-control-sm text-center rounded-3 border-0 shadow-sm"
                            style={{
                              width: 160,
                              margin: "0 auto",
                              background: "#f8f9fa",
                              fontWeight: "500",
                            }}
                            value={row.warehouse || row.warehouseName || ""}
                            onChange={(e) => onWarehouseChange(e, index)}
                            placeholder="Warehouse"
                          />
                        </td>
                      )}

                      <td className="py-3 px-4">
                        <input
                          type="number"
                          min="0"
                          step="any"
                          inputMode="decimal"
                          disabled={disableQty}
                          className="form-control form-control-sm text-center rounded-3 border-0 shadow-sm"
                          style={{
                            width: "120px",
                            margin: "0 auto",
                            background: "#f8f9fa",
                            fontWeight: "500",
                          }}
                          value={row.quantity ?? ""}
                          onBlur={recomputeFromComponents}
                          onChange={(e) => onChange(e, index)}
                        />
                      </td>

                      {showAmountDirect && (
                        <td className="py-3 px-4 text-center">
                          <span className="fw-semibold text-success">
                            {row?.costDirect || "0"}
                          </span>
                        </td>
                      )}

                      {showRemaining && (
                        <td className="py-3 px-4 text-center">
                          <span className="badge bg-info-subtle text-info px-3 py-2">
                            {row?.remaining || row?.remainingQty || "0"}
                          </span>
                        </td>
                      )}

                      {showQuantityApprove && (
                        <td className="py-3 px-4">
                          <input
                            type="number"
                            min="0"
                            disabled={disableQtyApprove}
                            className="form-control form-control-sm text-center rounded-3 border-0 shadow-sm"
                            style={{
                              width: "80px",
                              margin: "0 auto",
                              background: "#f8f9fa",
                              fontWeight: "500",
                            }}
                            value={row.quantityApprove ?? ""}
                            onChange={(e) => onChange2(e, index)}
                          />
                        </td>
                      )}

                      {showQuantityReceivePartial && (
                        <td className="py-3 px-4">
                          <input
                            type="number"
                            min="0"
                            disabled={disableQtyApprove}
                            className="form-control form-control-sm text-center rounded-3 border-0 shadow-sm"
                            style={{
                              width: "80px",
                              margin: "0 auto",
                              background: "#f8f9fa",
                              fontWeight: "500",
                            }}
                            onChange={(e) => onChange2(e, index)}
                            defaultValue={"0"}
                          />
                        </td>
                      )}
                    </tr>
                    {showDetailsRow && (
                      <tr style={{ background: "#f8fdf5" }}>
                        <td colSpan={baseCols} className="py-3 px-4">
                          <div className="row g-3">
                            <div className="col-md-4">
                              <div className="d-flex align-items-center gap-2">
                                <label
                                  className="mb-0 text-muted small fw-semibold"
                                  style={{ minWidth: 110 }}
                                >
                                  Net Price :
                                </label>
                                <input
                                  type="number"
                                  min="0"
                                  step="0.01"
                                  className="form-control form-control-sm text-end rounded-3 border-0 shadow-sm"
                                  style={{
                                    background: "#fff",
                                    fontWeight: "500",
                                  }}
                                  value={row.netPrice ?? row.cost ?? ""}
                                  onChange={(e) => onNetPriceChange(e, index)}
                                  placeholder="100"
                                />
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="d-flex align-items-center gap-2">
                                <label
                                  className="mb-0 text-muted small fw-semibold"
                                  style={{ minWidth: 110 }}
                                >
                                  Discount :
                                </label>
                                <input
                                  type="number"
                                  min="0"
                                  step="0.01"
                                  className="form-control form-control-sm text-end rounded-3 border-0 shadow-sm"
                                  style={{
                                    background: "#fff",
                                    fontWeight: "500",
                                  }}
                                  value={row.discount ?? ""}
                                  onChange={(e) => onDiscountChange(e, index)}
                                  placeholder="50"
                                />
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="d-flex align-items-center gap-2">
                                <label
                                  className="mb-0 text-muted small fw-semibold"
                                  style={{ minWidth: 110 }}
                                >
                                  Total Amount :
                                </label>
                                <input
                                  type="number"
                                  readOnly
                                  className="form-control form-control-sm text-end rounded-3 border-0 shadow-sm"
                                  style={{
                                    background: "#e8f5e9",
                                    fontWeight: "600",
                                    color: "#2e7d32",
                                  }}
                                  value={row?.cost * row?.quantity}
                                  placeholder="0"
                                />
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))
              ) : (
                <tr>
                  <td colSpan={baseCols} className="text-center py-5">
                    <div className="d-flex flex-column align-items-center gap-3">
                      <div
                        className="rounded-circle d-flex align-items-center justify-content-center"
                        style={{
                          width: "80px",
                          height: "80px",
                          background:
                            "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                        }}
                      >
                        <svg
                          width="40"
                          height="40"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#adb5bd"
                          strokeWidth="2"
                        >
                          <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                        </svg>
                      </div>
                      <div>
                        <h6 className="text-muted mb-1">No items found</h6>
                        <p className="text-muted small mb-0">
                          Please add items to get started
                        </p>
                      </div>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
